import { render, staticRenderFns } from "../../assets/templates/StartPlataformas/CompaniesPlataformas.html?vue&type=template&id=afbfd70e&scoped=true&"
import script from "../../assets/scripts/StartPlataformas/CompaniesPlataformas.js?vue&type=script&lang=js&"
export * from "../../assets/scripts/StartPlataformas/CompaniesPlataformas.js?vue&type=script&lang=js&"
import style0 from "../../assets/scss/startPlataformas.scss?vue&type=style&index=0&id=afbfd70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbfd70e",
  null
  
)

export default component.exports